import React, { useEffect, useState } from 'react';
import {Modal, Input, Table, Pagination, Space} from 'antd';
import {ColumnsType} from "antd/es/table";
import {getEpisodeBackgrounds} from "../../helpers/api/episode";

const { Search } = Input;


interface EpisodeBackgroundModel {
    key: React.Key;
    id: string;
    name: string;
    backgroundUrl: string;
}


const BackgroundSelectionModal = (
    {
        open,
        onClose,
        onConfirm = (backgroundId :  any) => {},
        backgrounds = [] as EpisodeBackgroundModel[],
        episodeId

    } :  any
) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([backgrounds]);
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [filters, setFilters] = useState({
        search: '',
    });


    // Columns cho Table
    const columns :  ColumnsType<EpisodeBackgroundModel> = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text, record, index) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span>{text}</span>
                    </div>
                );
            }
        },
        {
            title: 'Image',
            dataIndex: 'backgroundUrl',
            key: 'backgroundUrl',
            render: (text, record, index) => {
                return (<>
                    {record.backgroundUrl && record.backgroundUrl.includes('.mp4') ? (
                        <video controls style={{width: '100px'}}>
                            <source src={record.backgroundUrl} type="video/mp4"/>
                            Your browser does not support the video element.
                        </video>

                    ) : (
                        <img
                            src={record.backgroundUrl}
                            alt={record.name}
                            style={{width: 50, height: 50, marginRight: 10}}
                        />
                        )}
                    </>
                );
            }
        },
    ];

    // Fetch data
    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await getEpisodeBackgrounds(episodeId, {
                name: filters.search,
                pageIndex: currentPage - 1,
                pageSize,
            });
            setData(response.data.data);
            setTotal(response.data.totalRecord);
        } catch (err) {
            console.error('Failed to fetch data', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (open) {
            fetchData();
        }
    }, [open, filters, currentPage, pageSize]);

    return (
        <Modal
           open={open}
            title="Select background"
            onCancel={onClose}
            footer={null}
            width={700}
        >
            <Space style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
                <Search
                    placeholder="Search name"
                    onSearch={(value) => setFilters({ ...filters, search: value })}
                    style={{ width: 400 }}
                />
            </Space>

            <Table
                rowKey="id"
                columns={columns}
                dataSource={data}
                loading={loading}
                pagination={false}
                onRow={(record) => ({
                    onClick: () => {
                        onConfirm(record.id);
                        onClose();
                    },
                })}
                rowClassName={() => 'clickable-row'}
                style={{ cursor: 'pointer', maxHeight: 400, overflowY: 'auto' }}
            />

            <Pagination
                style={{ marginTop: 16, textAlign: 'right' }}
                current={currentPage}
                pageSize={pageSize}
                total={total}
                onChange={(page, pageSize) => {
                    setCurrentPage(page);
                    setPageSize(pageSize);
                }}
                showSizeChanger
            />
        </Modal>
    );
};

export default BackgroundSelectionModal;
